import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { ProjectDuplicateOffTheShelfOfferPage } from '@/areas/offers/StandardPartOfferForm/pages/ProjectDuplicateOffTheShelfOfferPage';
import { sourcingEditModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/projects/$projectId/sourcing/offer/off-the-shelf/$offerId/duplicate',
)({
    staticData: {
        access: { permissions: ['view:sourcing'], modulePermissions: sourcingEditModulePermissions },
        chrome: 'project',
    } satisfies PageStaticData,
    validateSearch: stringSearch({ sourcingLineItemId: 'optional' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    const sourcingLineItemId = Route.useSearch({ select: (search) => search.sourcingLineItemId });
    return (
        <ProjectDuplicateOffTheShelfOfferPage
            projectId={pathParams.projectId}
            offerId={pathParams.offerId}
            sourcingLineItemId={sourcingLineItemId}
        />
    );
}
